import { ColumnDef } from '@tanstack/react-table'
import { useTranslation } from 'react-i18next'

import { LastModifiedCell } from 'components/Table'
import { COLUMN_SIZE } from 'components/Table/constants'
import { DomainAlerts } from 'features/inventory/domain'
import ActionsCell from './components/ActionsCell'
import { Alert } from './hooks/useGetAlerts'
import { useProductSwitchColumns } from './hooks/useProductSwitchColumns'
import { AdUnitForTable } from './types/model'

type Props = {
  alerts: Alert[]
  count: number
}

export const useColumns = ({ alerts, count }: Props): ColumnDef<AdUnitForTable>[] => {
  const { t } = useTranslation('features/adUnit')
  const productColumns = useProductSwitchColumns({
    tableItemsCount: count,
  })

  return [
    {
      accessorKey: 'domain.name',
      header: t('list.header.domainName'),
      meta: { whiteSpacePre: true },
      size: COLUMN_SIZE.LG,
    },
    {
      accessorKey: 'name',
      header: t('list.header.adUnitName'),
      meta: { whiteSpacePre: true },
    },
    {
      accessorKey: 'path',
      header: t('list.header.adUnitPath'),
      meta: { whiteSpacePre: true },
    },
    {
      accessorKey: 'divId',
      header: t('list.header.divId'),
    },
    ...productColumns,
    {
      accessorKey: 'alerts',
      cell: ({
        row: {
          original: { id: domainId },
        },
      }) => <DomainAlerts alerts={alerts.find(({ id }) => id === domainId)?.alerts ?? []} />,
      header: t('list.header.alerts'),
      meta: { nonClickable: true },
    },
    {
      accessorKey: 'updatedAt',
      cell: props => <LastModifiedCell {...props} />,
      header: t('list.header.lastModified'),
    },
    {
      cell: ({ row }) => <ActionsCell {...row.original} />,
      header: t('list.header.actions'),
      id: 'actions',
      meta: {
        centered: true,
        nonClickable: true,
      },
      size: COLUMN_SIZE.SM,
    },
  ]
}
